<template>
  <v-card class="card-container">
    <v-dialog v-model="addModal" max-width="500" persistent>
      <Manage
        @close=";(addKey = !addKey), (addModal = false)"
        @confirm=";(addKey = !addKey), list(), (addModal = false)"
        :key="addKey"
      />
    </v-dialog>
    <v-dialog v-model="removeModal" max-width="400" persistent>
      <v-card class="pa-4 text-center" :key="removeKey">
        <h3 class="mb-4">Remover vídeo</h3>
        <p>
          Tem certeza de que deseja <strong>remover</strong> o vídeo
          <strong>"{{ current.title }}"</strong>
        </p>

        <v-btn class="primary-button" depressed @click="removeModal = false">
          Cancelar
        </v-btn>
        <v-btn
          class="secondary-button mr-0"
          depressed
          @click="remove"
          :loading="loading"
        >
          Remover
        </v-btn>
      </v-card>
    </v-dialog>

    <div class="main-toolbar">
      <div class="icon-back">
        <v-icon id="icon" size="37" color="white"> mdi-video </v-icon>
      </div>

      <span class="main-toolbar-title">Vídeos</span>

      <v-spacer></v-spacer>

      <v-btn
        depressed
        dark
        class="mr-2 hidden-sm-and-down secondary-button"
        @click=";(addKey = !addKey), (addModal = true)"
        v-if="user.mainType == 0"
      >
        {{ $t('Adicionar') }}
      </v-btn>
    </div>

    <v-row class="ma-0 mt-4">
      <v-col cols="12" sm="6" md="4" v-for="video in videos" :key="video.id">
        <v-dialog max-width="800">
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot="{ hover }">
              <v-card
                id="video"
                outlined
                class="pa-4 rounded-lg"
                :class="{ 'on-hover': hover }"
              >
                <img
                  v-bind="attrs"
                  v-on="on"
                  :src="`https://vumbnail.com/${video.link}.jpg`"
                  alt=""
                  class="videoImage mb-2"
                />
                <div class="d-flex justify-space-between align-center">
                  <strong>{{ video.title }}</strong>
                  <v-btn
                    text
                    icon
                    small
                    @click="
                      ;(current = video),
                        (removeKey = !removeKey),
                        (removeModal = true)
                    "
                    v-if="user.mainType == 0"
                  >
                    <v-icon color="error">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>

                <div class="btn-container">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :class="{ 'show-btns': hover }"
                    :color="transparent"
                    icon
                    x-large
                    text
                  >
                    <v-icon
                      :class="{ 'show-btns': hover }"
                      x-large
                      :color="transparent"
                    >
                      mdi-play
                    </v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-hover>
          </template>

          <v-card class="pa-4">
            <h3 class="ml-3">{{ video.title }}</h3>

            <div class="d-flex justify-center align-center">
              <iframe
                :src="`https://player.vimeo.com/video/${video.link}?h=a75baf7391`"
                width="740"
                height="460"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <div class="registros" v-if="videos.length">
          <span> 1 - {{ videos.length }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import Manage from './components/manage.vue'

export default {
  name: 'VideosPage',

  components: {
    Manage,
  },

  data() {
    return {
      user: {},
      loading: false,
      removeKey: false,
      current: {},
      totalPages: 0,
      totalItems: 0,
      addKey: false,
      addModal: false,
      removeModal: false,
      transparent: 'rgba(255, 255, 255, 0)',
      videos: [],
      page: 1,
      apiService: new ApiService(),
      institution: {},
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.list()
  },

  methods: {
    remove() {
      this.loading = true
      this.apiService
        .delete(`video/${this.current.id}`)
        .then(() => {
          this.loading = false
          this.removeModal = false
          this.current = {}
          this.$toast.success('Vídeo removido com sucesso!')
          this.list()
        })
        .catch(() => {
          this.loading = false
        })
    },

    list() {
      this.apiService.get(`video/paginate/${this.page}`).then((response) => {
        this.videos = response.content.videos.map((x) => {
          const linkArray = x.link.split('/')
          const link = linkArray[linkArray.length - 1]
          return {
            id: x.id,
            title: x.title,
            link: link,
          }
        })

        this.page = response.content.pager.currentPage
        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
      })
    },
  },

  watch: {
    page() {
      this.list()
    },
  },
}
</script>

<style scoped>
.btn-container {
  position: absolute;
  margin: auto;
  top: 34%;
  left: 42%;
}

#video {
  transition: opacity 0.4s ease-in-out;
  position: relative;
}

#video:not(.on-hover) {
  opacity: 0.8;
}

.show-btns {
  color: #fff !important;
}

.videoImage {
  border-radius: 10px;
  width: 100%;
}
</style>
